import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_LIST_PHIKHACHANGKY,
  GET_LIST_PHIKHACHANGKY_CHOVAY,
} from "actions/PhiKhacHangKy/actionTypes";
import { getListPhiKhacHangKySuccess, getListPhiKhacHangKyFailure } from "actions/PhiKhacHangKy";
import PhiKhacHangKyApi from "service/phiKhacHangKyApi";
import { pushNotification } from "utils/notifications";

function* getListPhiKhacHangKy(action) {
  try {
    const response = yield call(PhiKhacHangKyApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListPhiKhacHangKySuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListPhiKhacHangKyFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListPhiKhacHangKyFailure());
  }
}
function* getListPhiKhacHangKyTheoChoVay(action) {
  try {
    const response = yield call(PhiKhacHangKyApi.listTheoChoVay, action.dataSearch);
    if (response.ok) {
      yield put(getListPhiKhacHangKySuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListPhiKhacHangKyFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListPhiKhacHangKyFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_PHIKHACHANGKY, getListPhiKhacHangKy);
  yield takeLatest(GET_LIST_PHIKHACHANGKY_CHOVAY, getListPhiKhacHangKyTheoChoVay);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
